import { render } from "./setCategoryGroup.vue?vue&type=template&id=f26e98f4&scoped=true"
import script from "./setCategoryGroup.vue?vue&type=script&lang=js"
export * from "./setCategoryGroup.vue?vue&type=script&lang=js"

import "./setCategoryGroup.vue?vue&type=style&index=0&id=f26e98f4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26e98f4"],['__file',"src/views/brand/components/setCategoryGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f26e98f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f26e98f4', __exports__)) {
    console.log('reload')
    api.reload('f26e98f4', __exports__)
  }
  
  module.hot.accept("./setCategoryGroup.vue?vue&type=template&id=f26e98f4&scoped=true", () => {
    console.log('re-render')
    api.rerender('f26e98f4', render)
  })

}


export default __exports__